import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLink from './components/AuthLink';
import './Navbar.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [userRole, setUserRole] = useState(localStorage.getItem('role'));
    const [userName, setUserName] = useState(localStorage.getItem('userName'));
    const navigate = useNavigate();

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu  = () => setIsOpen(false);

    useEffect(() => {
        const onStorage = () => {
            setUserRole(localStorage.getItem('role'));
            setUserName(localStorage.getItem('userName'));
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('email');
        setUserRole(null);
        setUserName(null);
        navigate('/');
    };

    const isSignedIn = Boolean(userRole);

    return (
        <header className="samudyoga-nav">
            <div className="nav-inner">

                <Link to="/" className="swadharma-lockup" onClick={closeMenu}>
                    <img src="/samudyoga-logo.png" alt="Samudyoga" className="nav-logo" />
                    <span className="lockup-text">
                        <span className="lockup-title">Samudyoga</span>
                        <span className="lockup-sub">A Dharma Poshanam initiative</span>
                    </span>
                </Link>

                <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
                    <AuthLink to="/job-listings" className="nav-link" onClick={closeMenu}>
                        Need a Job?
                    </AuthLink>
                    <AuthLink to="/post-job" className="nav-link" onClick={closeMenu}>
                        Post a Job?
                    </AuthLink>
                    <AuthLink to="/refer" className="nav-link" onClick={closeMenu}>
                        Refer a Job?
                    </AuthLink>
                    <AuthLink to="/collaborate" className="nav-link" onClick={closeMenu}>
                        Collaborate with Swadharma
                    </AuthLink>
                    <Link to="/apps" className="nav-link" onClick={closeMenu}>
                        Swadharma Apps
                    </Link>
                    <AuthLink to="/contact-us" className="nav-link" onClick={closeMenu}>
                        Contact
                    </AuthLink>
                </nav>

                <div className={`nav-actions ${isOpen ? 'open' : ''}`}>
                    {isSignedIn ? (
                        <>
                            <span className="nav-greet">
                                <span className="nav-avatar">
                                    {(userName || 'U').trim().charAt(0).toUpperCase()}
                                </span>
                                <span className="nav-greet-text">{userName || 'User'}</span>
                            </span>
                            <button className="sw-btn sw-btn-ghost sw-btn-sm" onClick={handleLogout}>
                                Sign out
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/signin" className="sw-btn sw-btn-ghost sw-btn-sm">Login</Link>
                            <Link to="/signup" className="sw-btn sw-btn-saffron sw-btn-sm">Register</Link>
                        </>
                    )}
                </div>

                <button
                    className="nav-toggle"
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                    aria-expanded={isOpen}
                >
                    <span /><span /><span />
                </button>

            </div>
        </header>
    );
};

export default Navbar;
